module.exports = __webpack_public_path__ + "img/water3-2.a0f0f9b5.jpg";